import $ from "jquery"
import _ from "underscore"
import Backbone from "backbone"
import IScroll from "iscroll"

Backbone.$ = $

import BasePage from "./_base"

import breakpoints from "../lib/breakpoints"
import dimensionsFromImageBlock from "../lib/dimensionsFromImageBlock"

const FeaturedExhibition = BasePage.fullExtend({
  events: {
    "click .box.box--image": "openImage",
    "click .featured-exhibition-overlay": "closeImage",
  },

  imageTemplate: _.template(
    `<div class="featured-exhibition-overlay">
      <div class="featured-exhibition-overlay-image">
        <%= image %>
      </div>
    </div>`
  ),

  initThis: function () {
    TAVOLOZZA.pubSub.on("app:resize", this.resizeExhibition, this)
    TAVOLOZZA.pubSub.on("app:resize:last", this.resizeOverlayImage, this)

    const $_desc = this.$el.find(".exhibition-details-text-description")
    if ($_desc) {
      const _el = $_desc[0]
      this.iscroll = new IScroll(_el, {
        mouseWheel: true,
        scrollbars: true,
        probeType: 2,
        preventDefault: false,
        eventPassthrough: false,
        resizeScrollbars: false,
        scrollbars: "custom",
      })
    }
  },

  resizeExhibition: function () {
    const contentHeight = this.contentHeight()

    const isTablet = TAVOLOZZA.view.w <= breakpoints.tablet
    this.$(".exhibition-details").css({
      height: isTablet ? null : contentHeight,
      minHeight: isTablet ? contentHeight : null
    })

    if (this.iscroll) {
      this.iscroll.refresh()
    }
  },

  resizeOverlayImage: function () {
    const w = TAVOLOZZA.view.w
    const h = TAVOLOZZA.view.h

    const maxW = w * 0.9
    const maxH = h * 0.85

    const imgSize = dimensionsFromImageBlock(
      this.$(".featured-exhibition-overlay-image")
    )
    if (imgSize) {
      let nW = maxW
      let nH = (imgSize.height / imgSize.width) * maxW

      if (nH > maxH) {
        nH = maxH
        nW = (imgSize.width / imgSize.height) * maxH
      }

      this.$(".featured-exhibition-overlay-image img").css({
        width: nW,
        height: nH,
      })
    }
  },

  openImage: function (e) {
    e.preventDefault()
    e.stopPropagation()

    const $el = $(e.currentTarget)
    const $imageBlock = $el.find(".imageBlock").clone()
    $imageBlock.find("img").removeAttr("style")

    this.$el.append(this.imageTemplate({ image: $imageBlock.html() }))

    this.resizeOverlayImage()
  },

  closeImage: function (e) {
    e.preventDefault()
    e.stopPropagation()

    const $el = $(e.currentTarget)
    $el.remove()
  },

  onPageRemoved: function () { },
})

export default FeaturedExhibition
